import type { App } from 'vue';
import { createPinia } from 'pinia';
import { resetSetupStore } from './plugins';

/**
 * 设置Vue存储插件pinia
 */
export function setupStore(app: App) {
  const store = createPinia();

  store.use(resetSetupStore);

  app.use(store);
}

// 导出所有store模块
export * from './modules/user';
export * from './modules/auth/index';
export * from './modules/route/index';
export * from './modules/app/index';
export * from './modules/theme/index';
export * from './modules/tab/index'; 